"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isScoreField = exports.isHiddenField = exports.isGroupField = exports.getInputComponentForField = void 0;
const CreditCardInput_1 = require("../../../../../inputs/CreditCardInput");
const TextInput_1 = require("../../../../../inputs/TextInput");
const DynamicOptionsInput_1 = require("../../../../../inputs/DynamicOptionsInput");
const ButtonOptionsInput_1 = require("../../../../../inputs/ButtonOptionsInput");
const SingleOptionsInput_1 = require("../../../../../inputs/SingleOptionsInput");
const MultiOptionsInput_1 = require("../../../../../inputs/MultiOptionsInput");
const BooleanInput_1 = require("../../../../../inputs/BooleanInput");
const DateInput_1 = require("../../../../../inputs/DateInput");
const NumberInput_1 = require("../../../../../inputs/NumberInput");
const TemperatureInput_1 = require("../../../../../inputs/TemperatureInput");
const EmailInput_1 = require("../../../../../inputs/EmailInput");
const AcceptLegalsInput_1 = require("../../../../../inputs/AcceptLegalsInput");
const PasswordInput_1 = require("../../../../../inputs/PasswordInput");
const PinInput_1 = require("../../../../../inputs/PinInput");
const PasswordConfirmInput_1 = require("../../../../../inputs/PasswordConfirmInput");
const TelephoneInput_1 = require("../../../../../inputs/TelephoneInput");
const MedicareNumberInput_1 = require("../../../../../inputs/MedicareNumberInput");
const TextNumberInput_1 = require("../../../../../inputs/TextNumberInput");
const CameraUploadInput_1 = require("../../../../../inputs/CameraUploadInput");
const LikertInput_1 = require("../../../../../inputs/LikertInput");
const RichContentEditorInput_1 = require("../../../../../inputs/RichContentEditorInput");
const ImageUploadInput_1 = require("../../../../../inputs/ImageUploadInput");
// _componentType included for use with integration tests
const getInputComponentForField = (field) => {
    switch (field.type) {
        case "acceptLegals":
            return {
                _componentType: "AcceptLegalsInput",
                component: AcceptLegalsInput_1.AcceptLegalsInput,
                clearable: false
            };
        case "boolean":
            return {
                _componentType: "BooleanInput",
                component: BooleanInput_1.BooleanInput
            };
        case "creditCard":
            return {
                _componentType: "CreditCardInput",
                component: CreditCardInput_1.CreditCardInput,
                clearable: false
            };
        case "date":
            return {
                _componentType: "DateInput",
                component: DateInput_1.DateInput,
                indentClear: true
            };
        case "email":
            return {
                _componentType: "EmailInput",
                component: EmailInput_1.EmailInput,
                indentClear: true
            };
        case "medicareNumber":
            return {
                _componentType: "MedicareNumberInput",
                component: MedicareNumberInput_1.MedicareNumberInput,
                indentClear: true
            };
        case "number":
            return {
                _componentType: "NumberInput",
                component: NumberInput_1.NumberInput
            };
        case "temperature":
            return {
                _componentType: "TemperatureInput",
                component: TemperatureInput_1.TemperatureInput
            };
        case "options":
            switch (field.variant) {
                case "dropdown":
                    if (field.allowMultiple) {
                        return {
                            _componentType: "MultiOptionsInput",
                            component: MultiOptionsInput_1.MultiOptionsInput,
                            supportsMultiple: true,
                            indentClear: true
                        };
                    }
                    else {
                        return {
                            _componentType: "SingleOptionsInput",
                            component: SingleOptionsInput_1.SingleOptionsInput,
                            indentClear: true
                        };
                    }
                case "inline":
                    return {
                        _componentType: "ButtonOptionsInput",
                        component: ButtonOptionsInput_1.ButtonOptionsInput,
                        supportsMultiple: true,
                        indentClear: true
                    };
            }
            return {
                _componentType: "DynamicOptionsInput",
                component: DynamicOptionsInput_1.DynamicOptionsInput,
                supportsMultiple: true,
                indentClear: true
            };
        case "password":
            return {
                _componentType: "PasswordInput",
                component: PasswordInput_1.PasswordInput,
                indentClear: true
            };
        case "passwordConfirm":
            return {
                _componentType: "PasswordConfirmInput",
                component: PasswordConfirmInput_1.PasswordConfirmInput,
                clearable: false
            };
        case "pin":
            return {
                _componentType: "PinInput",
                component: PinInput_1.PinInput,
                indentClear: true
            };
        case "phone":
            return {
                _componentType: "TelephoneInput",
                component: TelephoneInput_1.TelephoneInput
            };
        case "text":
        case "name":
        case "surname":
        case "dvaNumber":
        case "concessionCardNumber":
            return {
                _componentType: "TextInput",
                component: TextInput_1.TextInput
            };
        case "IHN":
        case "textNumber":
            return {
                _componentType: "TextNumberInput",
                component: TextNumberInput_1.TextNumberInput
            };
        case "camera": {
            return {
                _componentType: "CameraUploadInput",
                component: CameraUploadInput_1.CameraUploadInput,
                indentClear: true
            };
        }
        case "likert": {
            return {
                _componentType: "LikeRatingOptions",
                component: LikertInput_1.LikertInput,
                indentClear: true
            };
        }
        case "imageUpload": {
            return {
                _componentType: "ImageUploadInput",
                component: ImageUploadInput_1.ImageUploadInput,
                indentClear: true
            };
        }
        case "richContent": {
            return {
                _componentType: "RichContentInput",
                component: RichContentEditorInput_1.RichContentEditorInput,
                indentClear: true
            };
        }
        default:
            throw new Error(`Unknown input type: ${field.type}`);
    }
};
exports.getInputComponentForField = getInputComponentForField;
const isGroupField = (field) => field.type === "group";
exports.isGroupField = isGroupField;
const isHiddenField = (field) => field.type === "hidden";
exports.isHiddenField = isHiddenField;
const isScoreField = (field) => field.type === "score";
exports.isScoreField = isScoreField;
//# sourceMappingURL=inputs.js.map